module.exports = __webpack_public_path__ + "img/UTFREM-15.f860af3d.jpg";